module.exports = __webpack_public_path__ + "../static/img/null.e2dfcd93.png";